import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { deviceId } from "./useCart";
import { accountKey } from "./razorpay";
import { isIosInAppBrowser } from "./browserContext";

const FIRST_SEEN = "sc_online_first_seen";
const read = (k) => { try { return localStorage.getItem(k); } catch { return null; } };

/* `?diag=1` — read-only field diagnostics for device retests: shows whether this browser context kept storage
   between opens (first-seen stamp), the remembered outlet/session, and why/if nearest-outlet GPS ran. */
export const DiagStrip = ({ slug, branchId, cartCount, session }) => {
  const [open, setOpen] = useState(true);
  const [, setTick] = useState(0);
  useEffect(() => { const iv = setInterval(() => setTick((n) => n + 1), 1000); return () => clearInterval(iv); }, []);   // re-read storage (the locate log is written after site load)
  if (!open) return null;
  if (!read(FIRST_SEEN)) { try { localStorage.setItem(FIRST_SEEN, new Date().toISOString()); } catch { /* ignore */ } }
  let log = null; try { log = JSON.parse(read(`sc_online_locate_log_${slug}`) || "null"); } catch { log = null; }
  const ua = navigator.userAgent;
  const rows = [
    ["Browser", `${isIosInAppBrowser(ua) ? "iOS in-app browser (WKWebView)" : /Safari\//.test(ua) && /iPhone|iPad/.test(ua) ? "iOS Safari" : "other"}${window.navigator.standalone ? " · home-screen" : ""}`],
    ["Storage first seen", read(FIRST_SEEN) || "—"],
    ["Device id", (deviceId() || "").slice(0, 8) + "…"],
    ["Remembered outlet", branchId ? branchId.slice(0, 8) + "…" : "none"],
    ["Cart lines", String(cartCount)],
    ["Session", read(accountKey(slug)) ? `token present · ${session.status}` : "none"],
    ["Nearest-outlet GPS", log ? `${log.reason} @ ${log.at.slice(11, 19)}Z` : "not run yet"],
    ["Order mode", read(`sc_online_mode_${slug}`) || "—"],
  ];
  return (
    <div role="status" data-testid="order-diag" style={{ position: "fixed", left: 8, right: 8, bottom: 8, zIndex: 9999, background: "#0f172a", color: "#e2e8f0", fontSize: 11, lineHeight: 1.35, borderRadius: 10, padding: "8px 10px", fontFamily: "ui-monospace, Menlo, monospace", pointerEvents: "none", opacity: 0.92 }}>
      <button type="button" onClick={() => setOpen(false)} aria-label="Close diagnostics" style={{ position: "absolute", top: 6, right: 6, background: "transparent", border: 0, color: "#94a3b8", pointerEvents: "auto" }} data-testid="order-diag-close"><X size={14} /></button>
      {rows.map(([k, v]) => <div key={k} data-testid={`order-diag-${k.toLowerCase().replace(/[^a-z]+/g, "-")}`}><span style={{ color: "#94a3b8" }}>{k}:</span> {v}</div>)}
      <div style={{ color: "#64748b", marginTop: 4, wordBreak: "break-all" }}>{ua}</div>
    </div>
  );
};
